import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/apiKey/importer/apiKeyImporterSelectors';
import ApiKeyService from 'src/modules/apiKey/apiKeyService';
import fields from 'src/modules/apiKey/importer/apiKeyImporterFields';
import { i18n } from 'src/i18n';

const apiKeyImporterActions = importerActions(
  'APIKEY_IMPORTER',
  selectors,
  ApiKeyService.import,
  fields,
  i18n('entities.apiKey.importer.fileName'),
);

export default apiKeyImporterActions;